import React, { useContext, useState, useEffect } from 'react'
import {
  ButtonsDiv,
  CloseDiv,
  CloseImg,
  Container,
  CreateButtonDiv,
  CreateButtonImage,
  CreateButtonText,
  ErrorMessage,
  HeaderDiv,
  HeaderText,
  InputDiv,
  InputField,
  LabelCreate,
  TipText,
  SelectField
} from './style'
import cross from '../../assets/addStockModal/cross.svg'
import plus from '../../assets/headers/plus.svg'
import ModalContext from '../../contexts/ModalContext'
import axios from '../../config/axios'
import { useProfileContext } from '../../contexts/AccessesContext'

const CreateAccessUserModal: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    company: '',
    cnpj: '',
    profileId: '',
  })
  const { setModalActive } = useContext(ModalContext)
  const { profiles } = useProfileContext()
  const [error, setError] = useState('')
  const [click, setClick] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchTenantData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/tenant`)
        console.log('✅ Dados da tenant:', response.data)

        if (response.data) {
          const company = response.data.companyName || ''
          const cnpj = (response.data.cnpj || '').replace(/[^\d]/g, '')

          console.log('📦 Company:', company, 'CNPJ:', cnpj)

          setFormData(prev => ({
            ...prev,
            company,
            cnpj,
          }))
        }
      } catch (error) {
        console.error('❌ Erro ao buscar dados da tenant:', error)
        setError('Erro ao carregar dados da empresa')
      } finally {
        setLoading(false)
      }
    }

    fetchTenantData()
  }, [])

  const validateForm = () => {
    if (!formData.name || formData.name.length < 3) return false
    if (!formData.email || !formData.email.includes('@')) return false
    if (!formData.password || formData.password.length < 6) return false
    if (!formData.phone || formData.phone.length < 10) return false
    return true
  }

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    setError('')
  }

  const createUser = async () => {
    console.log('🚀 Iniciando criação de usuário...')
    console.log('📝 FormData atual:', formData)

    if (!validateForm()) {
      console.log('❌ Validação falhou')
      setClick(true)
      return
    }

    if (!formData.company || !formData.cnpj) {
      console.log('⚠️ Company ou CNPJ vazios:', { company: formData.company, cnpj: formData.cnpj })
      setError('Carregando dados da empresa...')
      return
    }

    try {
      const userData = {
        ...formData,
        profileId: formData.profileId ? Number(formData.profileId) : null,
        adminUser: false,
        role: 'TENANT_USER',
        picture: '',
        approved: 'pending',
        permissions: [],
      }

      console.log('📤 Enviando dados do usuário:', userData)
      await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user`, userData)
      console.log('✅ Usuário criado com sucesso!')
      setModalActive(false)
      window.location.reload()
    } catch (error: any) {
      console.error('❌ Erro ao criar usuário:', error)
      if (error.response?.status === 409) {
        setError('Usuário com este email já existe')
      } else if (error.response?.status === 400) {
        const messages = error.response?.data?.message
        if (Array.isArray(messages)) {
          setError(messages.join(', '))
        } else {
          setError('Dados inválidos. Verifique os campos obrigatórios.')
        }
      } else {
        setError('Erro ao criar usuário')
      }
    }
  }

  const isValid = validateForm()

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Cadastrar novo usuário</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>

      {loading && <p>Carregando dados...</p>}
      {error && <ErrorMessage>{error}</ErrorMessage>}

      <InputDiv>
        <LabelCreate>Nome completo *</LabelCreate>
        <InputField
          placeholder='Digite o nome completo'
          type='text'
          value={formData.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('name', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Email *</LabelCreate>
        <InputField
          placeholder='Digite o email'
          type='email'
          value={formData.email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('email', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Senha *</LabelCreate>
        <InputField
          placeholder='Digite a senha (mínimo 6 caracteres)'
          type='password'
          value={formData.password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('password', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Telefone *</LabelCreate>
        <InputField
          placeholder='Digite o telefone'
          type='text'
          value={formData.phone}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('phone', e.target.value)}
        />
      </InputDiv>

      <InputDiv>
        <LabelCreate>Perfil de acesso (opcional)</LabelCreate>
        <SelectField
          value={formData.profileId}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => handleInputChange('profileId', e.target.value)}
        >
          <option value="">Sem perfil</option>
          {profiles.map((profile) => (
            <option key={profile.id} value={profile.id}>
              {profile.name}
            </option>
          ))}
        </SelectField>
      </InputDiv>

      <ButtonsDiv>
        {!isValid && click && (
          <TipText>Preencha todos os campos obrigatórios corretamente</TipText>
        )}
        <CreateButtonDiv onClick={createUser}>
          <CreateButtonImage src={plus} alt='Plus icon' />
          <CreateButtonText>Cadastrar usuário</CreateButtonText>
        </CreateButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default CreateAccessUserModal
